// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.fees.multifamily.disclaimer.RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

import type { DeleteMultifamilyListingFeeDisclaimerRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete_Args {
  postData: DeleteMultifamilyListingFeeDisclaimerRequestDto;
}

export type RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete_Args
>;

/**
 * Deletes a fee disclaimer for a multi family listing
 */
export const useRentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete_Args) =>
      RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete(args.postData, httpClient),
  });
};
